Librarian.Modules.Recent = new Class({
    Extends: Librarian.Modules.Module,
    Binds: ["onRecentLoaded", "prepCartItem"],

    options: {
        classPrefix: "modules-recent-",
        catType: Librarian.catType.file,
        count: 20,
        action: "open", // "download", or "preview"
        showDate: false,
        detailed: false,
        spinner: false,
        showAuthor: false,
        showModDate: false,
        viewAll: false,
        showGetLink: false,
        showShareLink: true,
        pageName: "Collateral"
    },

    initialize: function(options, wrapperEl) {
        this.setOptions(options);
        this.parent(this.options, wrapperEl);
    },

    load: function() {
        if (!this.wrapperEl || (typeof this.options.catType != "number"))
            return;

        this.parent();

        if (this.options.spinner) {
            this.loadingImage = new Element("div",
            {
                "class": "recentLoadingSpinner"
            }).inject(this.wrapperEl);
        }

        var func = null;

        if (this.options.catType === Librarian.catType.file)
            func = Librarian.Utils.getNewestFiles(this.options.count, this.onRecentLoaded, null, null, null, this.options.useGetSendData, this.options.customSendData);
        else if (this.options.catType === Librarian.catType.globalFavorite)
            func = Librarian.Utils.getNewestGroups;

        if (typeof func != "function")
            return;

        func(this.options.count, this.onRecentLoaded, null, "ujson");
    },

    onRecentLoaded: function(items) {
        // remove loading image
        if (this.loadingImage) {
            this.wrapperEl.getElements(".recentLoadingSpinner").destroy();
        }

        var self = this;
        if (!items || (items.length == 0))
            return;

        if (items.data)
            items = items.data;

        // Create the container element
        var listEl = new Element("ul", {
            "class": "content-list"
        }).injectInside(this.containerEl);

        if (this.options.viewAll) {
            var viewAllEl = new Element("span", {
                "class": "content-view-all",
                "text": "View All"
            }).injectInside(this.headerEl);

            viewAllEl.addOnClick(function() {
                Librarian.Modules.Nav.navigateToPage(self.options.pageName);
            });
        }

        items.forEach(function(item) {
            var data = Object.toLowerKeys(item),
                value = (self.options.showDate
                        ? Librarian.Utils.extractDateFromString(data.importdate).format("%m/%d/%Y") + " - "
                        : '') + data.name;

            var listItemEl = new Element("li", {
                "class": "content-item"
            }).injectInside(listEl);

            var iconEl = new Element("img", {
                "class": "content-icon",
                src: Librarian.Utils.getContentTypeIcon(data)
            }).injectInside(listItemEl);

            var linkEl = new Element("span", {
                "class": "content-name",
                "text": value,
                "title": data.name
            }).injectInside(listItemEl);

            if (self.options.detailed) {

                var bookmarkEl = new Element("div", {
                    "class": "content-bookmark"
                }).injectInside(listItemEl);            

                Librarian.Bookmarks.getBookmarkId(data.contentid,
                    data.contenttype,
                    function(bookmarkId) {
                        if (bookmarkId > 0) {
                            bookmarkEl.addClass("bookmarked");
                            bookmarkEl.bookmarkId = bookmarkId;
                        }
                    });

                var threeDotEl = new Element("div", {
                    "class": "content-menu-icon"
                }).injectInside(listItemEl);

                var menuEl = new Element("div", {
                    "class": "content-menu-wrapper"
                }).injectInside(listItemEl);

                var downloadEl = new Element("div", {
                    "text": "Download"
                }).injectInside(menuEl);

                var cartEl = new Element("div", {
                    "text": "Add File"
                }).injectInside(menuEl);

                if (self.options.showShareLink) {
                    var shareEl = new Element("div", {
                        "text": "Share"
                    }).injectInside(menuEl);
                }

                var viewEl = new Element("div", {
                    "text": "View in Library"
                }).injectInside(menuEl);

                if (self.options.showGetLink) {
                    var getLinkEl = new Element("div", {
                            "text": "Get Link"
                    }).injectInside(menuEl);

                    getLinkEl.addOnClick(function() {
                        Librarian.Utils.getLink(data);
                    });
                }

                menuEl.hide();

                threeDotEl.addEvent('mouseenter', function() {
                    menuEl.show();
                    menuEl.removeClass("open-above");

                    var menuRect = menuEl.getBoundingClientRect();
                    var contRect = self.containerEl.getBoundingClientRect();
                    var openAbove = menuRect.bottom > contRect.bottom;

                    menuEl.toggleClass("open-above", openAbove);

                    menuRect = menuEl.getBoundingClientRect();
                    var openLeft = menuRect.top < contRect.top;

                    menuEl.toggleClass("open-left", (openAbove && openLeft));

                    threeDotEl.addClass("active");
                });

                menuEl.addEvent('mouseenter', function() {
                    menuEl.show();
                    threeDotEl.addClass("active");
                });

                threeDotEl.addEvent('mouseleave', function() {
                    menuEl.hide();
                    threeDotEl.removeClass("active");
                });

                menuEl.addEvent('mouseleave', function() {
                    menuEl.hide();
                    threeDotEl.removeClass("active");
                });

                downloadEl.addOnClick(function () {
                    Library.downloadData(data);
                });

                cartEl.addOnClick(function () {
               // Can't add to the cart if we don't have a cart
                    if (!Librarian.userCart)
                        return;

                    var item = self.prepCartItem(data, 1),
                        onComplete = function(success, notifyType) {
                            Librarian.Utils.showCartNotification(item, notifyType, success);

                            // Update the checkboxes on the main page
                            Librarian.Utils.updateAllCheckboxes();

                            Librarian.Cart.onChange();

                            // If we're in the cart and we just removed ourselves,
                            // close the window to prevent switching errors.
                            if (success && (notifyType == Librarian.cartNotificationTypes.removed) && this.isInCart)
                                this.close();
                        }.bind(this);

                    // If it's already in the cart, prompt the user to remove it
                    if (Librarian.userCart.isInCart(item, true)) {
                        Librarian.userCart.removeFromCart(item, null, null, null, null, function() {
                            onComplete(!Librarian.userCart.isInCart(item), Librarian.cartNotificationTypes.removed);
                        });
                    }
                        // Otherwise, add it
                    else
                        onComplete(Librarian.userCart.addToCart(item), Librarian.cartNotificationTypes.added);
                });

                if (shareEl) {
                    shareEl.addOnClick(function () {
                        var eventType = Librarian.eventType.oneOff;
                        this.sendWindow = new Librarian.EventSendWindow({
                            onCloseComplete: function () {
                                this.sendFileWindow = null;
                            }.bind(this),
                            eventType: eventType
                        }, data);
                        this.sendWindow.show();
                    });
                }

                viewEl.addOnClick(function () {
                    var tree = Library.getTreeByType(Librarian.catType.file, null, data.prestype);
                    Librarian.Utils.getPath(data, function(path) {
                        if (path != null)
                            Library.loadLibraryTab();
                            Librarian.Utils.selectTreeNodeByPath(tree, path);
                    });
                });

                new Element('span', {
                    "class": "content-field",
                    "text": "Last Modifed: " + Librarian.Utils.getDateValue(data.lastmoddate, "%x %X")
                }).injectInside(listItemEl);

                new Element('span', {
                    "class": "content-field",
                    "text": "Author: " + (data.extrafields.Author || "")
                }).injectInside(listItemEl);

                bookmarkEl.addOnClick(function() {
                    var self = this;
                    if (this.hasClass("bookmarked")) {
                        Librarian.Bookmarks.deleteBookmark(this.bookmarkId,
                            data.contentid,
                            data.contenttype,
                            function() {
                                self.removeClass("bookmarked");
                            }.bind(this));

                    } else {
                        Librarian.Bookmarks.addBookmark(data.contentid,
                            data.contenttype,
                            function(bookmarkId) {
                                self.addClass("bookmarked");
                                this.bookmarkId = bookmarkId;
                            }.bind(this));
                    }
                });
            }

            // Add the onClick handler to open the Preview window if that is our set action
            if (self.options.action === "preview") {
                linkEl.data = data;
                linkEl.addOnClick(function() {
                    Librarian.PreviewWindow.openPreviewWindow(this.data);
                });
            }
            // Otherwise, if the set action is to open the location of the file
            else if (self.options.action === "open") {
                var url = '#';

                // Build the url from the data we have
                if (data.fileid > 0)
                    url += "fileid=" + data.fileid;
                else if (data.groupid > 0)
                    url += "groupid=" + data.groupid;

                // Including the cat ID if we have it
                if (data.extrafields && data.extrafields.CatID != null)
                    url += "&catid=" + data.extrafields.CatID;
                else if (data.catid > 0)
                    url += "&catid=" + data.catid;

                // And set that as the url for this link
                linkEl.href = url + "&type=" + this.options.catType;
            }
            // Lastly, if the set action is to download and this is a file
            else if ((this.options.action === "download") && (data.fileid > 0)) {
                // Set the source and target
                linkEl.href = Librarian.Utils.getFileDownloadUrl(data.fileid);
                linkEl.target = "_download";
            }
        });
    },

    prepCartItem: function(data, type) {
        if (!Librarian.Cart)
            return data;

        var item = new Librarian.Cart.Item(data);
        if ((type == Librarian.Utils.getItemTypeString(this.options.data)) && (this.options.data.slidenumber < 1))
            item.slidenumber = 1;
            // Files
        else if (type == Librarian.Lang.getString("item")) {
            if (this.options.data.slidenumber != 0)
                item.slidenumber = 0;
            item.itemnumber = undefined;
            if (this.options.data.slideid != 0)
                item.slideid = 0;
            // Restore the parent extra fields if we're adding this as an item
            if (this.options.parentData && this.options.parentData.extrafields)
                item.extrafields = this.options.parentData.extrafields;
        }
            // Slides/Pages
            // If there is parent data and they have extra fields, save the extrafields as parents fields
        else if (this.options.parentData && this.options.parentData.extrafields)
            item.parentfields = this.options.parentData.extrafields;

        // Reset the add type for this item so the cart can process it correctly
        item.addType = null;

        return item;
    }
});